/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Steps_IntroInputs */

const es_cap_steps_intro = /** @type {(inputs: Cap_Steps_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrarte es gratis. Solo cobramos cuando tú cobras: trabajas, navegas y te llevas tu tarifa.`)
};

const gl_cap_steps_intro = /** @type {(inputs: Cap_Steps_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexistrarte é de balde. Só cobramos cando ti cobras: traballas, navegas e levas a túa tarifa.`)
};

const en_cap_steps_intro = /** @type {(inputs: Cap_Steps_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing up is free. We only earn when you do: you work, sail, and keep your rate.`)
};

/**
* | output |
* | --- |
* | "Signing up is free. We only earn when you do: you work, sail, and keep your rate." |
*
* @param {Cap_Steps_IntroInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_steps_intro = /** @type {((inputs?: Cap_Steps_IntroInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Steps_IntroInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_steps_intro(inputs)
	if (locale === "en") return en_cap_steps_intro(inputs)
	return es_cap_steps_intro(inputs)
});